import Vue from 'vue';
const ZonaEventBus = new Vue();
export default ZonaEventBus;
